import { L10n } from '../../../../ts/L10n/L10n';
import { IGroupBasicInfo, IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { Set } from '../../../../ts/models/Set';
import { Groups } from '../../Groups';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { DeleteGroupsNotificationAction } from '../notifications/DeleteGroupsNotificationAction';
import { Messages } from '../../../../codegen/Localize';
import { openReactConfirmationDialog } from '../../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';

function showDeleteGroupDialog(
  groups: Set<IGroupBasicInfo>): Promise<any> {

  let dialogBody: string;

  if (groups.size() === 1) {
    const group = groups.first();
    dialogBody = Messages.confirmDeleteGroup({ GROUP_NAME: L10n.elideIfLong(group.name) });
  } else {
    dialogBody = Messages.confirmDeleteGroups({ GROUP_COUNT_LOC: L10n.localizedCount(groups.size()) });
  }

  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.deleteMessage(),
    message: dialogBody,
    actionName: Messages.confirmDeleteButton({ ITEM_COUNT: groups.size() , ITEM_COUNT_LOC: L10n.localizedCount(groups.size()) }),
    isActionDelete: true,
    action: Groups.deleteGroups.bind(Groups),
    paramsForAction: groups.keys(),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    DeleteGroupsNotificationAction.notify(result, groups);
  });

  return Promise.resolve(dialogInstance.result);
}

function deleteGroup(group: IGroupBasicInfo): Promise<any> {
  const groups = new Set<IGroupBasicInfo>((group: IGroupInfo) => group.id);
  groups.add(group);
  return DeleteGroupAction.showDeleteGroupDialog(groups);
}

export const DeleteGroupAction = {
  showDeleteGroupDialog,
  deleteGroup
};

export type DeleteGroupAction = typeof DeleteGroupAction;
